<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';

  import axios from 'axios';

  import LikeProduct from '../LikeProduct';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'search-spare-parts',

    components: {
      LikeProduct
    },

    props: [
      'language'
    ],

    watch: {
      'search': 'searchSpareParts'
    },

    data() {
      return {
        spareParts: [],

        search: ''
      }
    },

    computed: {
      filteredItems() {
        if (this.search == null || this.search == '') {
          return [];
        }

        return this.spareParts.filter(item => {
          var searchString = item.name + ' ' + item.visma_product_no;

           return searchString.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        })
      },

      placeholderText() {
        if (this.language == 'sv') {
          return 'Sök reservdelar';
        }

        return 'Search spare parts';
      }
    },

    methods: {
      searchSpareParts() {
        var self = this;

        if (this.search == null || this.search == '') {
          this.$root.$emit('searchIsActive', false);
          this.spareParts = [];
          this.loading = false;
        } else {
          this.loading = true;
          this.$root.$emit('searchIsActive', true);

          axios.post('/api/v1/spareparts/search', {
            language: this.language,
            search: this.search
          })
          .then(function (response) {
            self.spareParts = response.data.data;
            self.loading = false;
          })
          .catch(function (error) {
            self.loading = false;

            console.log("Error fetching spare parts: ", error);
          });
        }
      },
    }
  };
</script>

<template>
  <div>
    <input type="text" v-model="search" :placeholder="placeholderText" class="spare-search">

    <div class="row mt-4">
      <div v-for="part in filteredItems" class="col-12 col-md-4 col-lg-3 mb-4">
         <div class="card">
          <div class="card-body">
            <like-product v-if="part.authenticated" :product-i-d="part.id" mode="mini" :liked="part.liked" :language="language"></like-product>

            <div class="card-img-actions">
              <a :href="part.product_url"><img :src="part.image_url" class="card-img img-fluid" width="200" height="200" alt=""></a>
            </div>
          </div>
          <div class="card-body bg-light text-center">
            <div class="mb-2">
              <h6 class="font-weight-semibold mb-2"> <a :href="part.product_url">{{ part.name }}</a> </h6>
            </div>

            <!-- Price -->
            <div v-if="part.authenticated">
              <p class="product-list-price">{{ part.price }}</p>

              <div v-if="part.in_stock">
                <p class="in-stock">{{ (language == 'sv') ? 'I lager' : 'In stock' }}</p>
              </div>

              <div v-if="!part.in_stock">
                <p class="out-of-stock">{{ (language == 'sv') ? 'Ej i lager' : 'Out of stock' }}</p>
              </div>
            </div>

            <div class="text-muted mb-3">{{ (language == 'sv') ? 'Artikelnr:' : 'Article no:' }} {{ part.visma_product_no }}</div>
            <a :href="part.product_url" type="button" class="btn btn-outline-dark">{{ (language == 'sv') ? 'Läs mer' : 'Read more' }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
